import { Box } from '@mui/material'
import React from 'react'
import { avatarPropStyles } from '../../../../../../../../core/styling/global';
import { UploadIcon } from '../../../../../../../../core/global/realproperty/styles/CustomStyles';


export const Images = ({ fileHandler, t_form, error }) => {
    const d = t_form.data.styles.names.images
    return (
        <Box width="100%" display="flex" flexDirection="column" alignItems="center" p="8px 40px 8px 40px" gap={3}>
            <Box width="100%" display="flex" flexDirection="column" alignItems="center">
                <Box color="#008000"> {error.data.proceed && d.first_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                <Box width="100%" bgcolor="#F1F1F1" height={456} borderRadius={4}
                p={error.data.proceed && d.first_img.type === 'default' && 1} border={error.data.proceed && d.first_img.type === 'default' && "red solid 2px"}
                >
                    <Box component="label" sx={{ cursor: 'pointer' }}>
                        <Box sx={avatarPropStyles(d.first_img.object, '100%', "100%", 4)}>

                            <UploadIcon />
                        </Box>
                        <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('first_img', e)} />
                    </Box>
                </Box>
            </Box>

            <Box position="relative" width="100%" display="flex" alignItems="center" gap={2}>
                <Box width="50%" position={"absolute"} mt={-2} top={0} color="#008000" fontSize={11}>{error.data.proceed && d.second_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                <Box width="100%">
                    <Box width="100%" bgcolor="#F1F1F1" borderRadius={4} height={256}
                    p={error.data.proceed && d.second_img.type === 'default' && 1} border={error.data.proceed && d.second_img.type === 'default' && "red solid 2px"}
                    >
                        <Box component="label" sx={{ cursor: 'pointer' }}>
                            <Box sx={avatarPropStyles(d.second_img.object, '100%', "100%", 4)}>
                                <UploadIcon />
                            </Box>
                            <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('second_img', e)} />
                        </Box>
                    </Box>
                </Box>
                <Box width="100%">
                    <Box width="50%" position={"absolute"} mt={-2} top={0} color="#008000" fontSize={11}>{error.data.proceed && d.third_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                    <Box width="100%" height={256} bgcolor="#F1F1F1" borderRadius={4}
                    p={error.data.proceed && d.third_img.type === 'default' && 1} border={error.data.proceed && d.third_img.type === 'default' && "red solid 2px"}
                    >
                        <Box component="label" sx={{ cursor: 'pointer' }}>
                            <Box sx={avatarPropStyles(d.third_img.object, '100%', "100%", 4)}>
                                <UploadIcon />
                            </Box>
                            <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('third_img', e)} />
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box width="100%" display="flex" flexDirection="column" alignItems="center">
                <Box color="#008000">{error.data.proceed && d.fourth_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                <Box width="100%" height={456} bgcolor="#F1F1F1" borderRadius={4}
                p={error.data.proceed && d.fourth_img.type === 'default' && 1} border={error.data.proceed && d.fourth_img.type === 'default' && "red solid 2px"}
                >
                    <Box component="label" sx={{ cursor: 'pointer' }}>
                        <Box sx={avatarPropStyles(d.fourth_img.object, '100%', "100%", 4)}>
                            <UploadIcon />
                        </Box>
                        <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('fourth_img', e)} />
                    </Box>
                </Box>
            </Box>

            <Box position="relative" width="100%" display="flex" alignItems="center" gap={2}>
                <Box width="50%" position={"absolute"} mt={-2} top={0} color="#008000" fontSize={11}>{error.data.proceed && d.fifth_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                <Box width="100%" sx={{ cursor: "pointer" }}>
                    <Box width="100%" height={256} bgcolor="#F1F1F1" borderRadius={4}
                    p={error.data.proceed && d.fifth_img.type === 'default' && 1} border={error.data.proceed && d.fifth_img.type === 'default' && "red solid 2px"}
                    >
                        <Box component="label" sx={{ cursor: 'pointer' }}>
                            <Box sx={avatarPropStyles(d.fifth_img.object, '100%', "100%", 4)}>
                                <UploadIcon />
                            </Box>
                            <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('fifth_img', e)} />
                        </Box>
                    </Box>
                </Box>
                <Box width="100%" sx={{ cursor: "pointer" }}>
                    <Box width="50%" position={"absolute"} mt={-2} top={0} color="#008000" fontSize={11}>{error.data.proceed && d.sixth_img.type === 'default' && 'This image is for default only. Please insert your own image!'}</Box>
                    <Box width="100%" height={256} bgcolor="#F1F1F1" borderRadius={4}
                    p={error.data.proceed && d.sixth_img.type === 'default' && 1} border={error.data.proceed && d.sixth_img.type === 'default' && "red solid 2px"}
                    >
                        <Box component="label" sx={{ cursor: 'pointer' }}>
                            <Box sx={avatarPropStyles(d.sixth_img.object, '100%', "100%", 4)}>
                                <UploadIcon />
                            </Box>
                            <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('sixth_img', e)} />
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* <Box sx={{ cursor: "pointer" }} mt={6} fontSize={24} fontWeight={600} borderBottom="solid 2px">Show me all Images.....</Box> */}

        </Box>
    )
}
